import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  IconButton,
  Tooltip,
  Typography,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import MUIDataTable from "mui-datatables";
import rest from "../../../rest";
import { MySnackbar } from "../../mySnackbar/MySnackbar";
import { AccessTime as AccessTimeIcon } from "@material-ui/icons";
import { ThemeProvider } from "@material-ui/core/styles";
import createCustomTheme from "../../dataTable/CustomThemeTable";
import { themeColors } from "../../css/themeConfig";
import { useSelector } from "react-redux";
import LoadingIndicator from "../../loadingIndicator/LoadingIndicator";
import textLabels from "../../dataTable/textLabel";

const SchedulerTable = ({ refreshParent }) => {
  const [data, setData] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [snack, setSnack] = useState({});
  const [loading, setLoading] = useState(true);
  const themeName =
    useSelector((state) => state.manif?.manifParams?.Theme) || "theme1";

  // Recup les mails programmés
  useEffect(() => {
    setLoading(true);
    rest
      .post("/email/getScheduledEmail")
      .then((response) => {
        setData(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error(
          "Une erreur s'est produite lors de la récupération des données getScheduledEmail :",
          error
        );
        setLoading(false);
      });
  }, [refresh, refreshParent]);

  const handleClickOpen = (id) => {
    setSelectedId(id);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleConfirmDelete = () => {
    rest
      .post("/email/deleteScheduedById", { vId: selectedId })
      .then((response) => {
        setData((prevData) =>
          prevData.filter((item) => item.ID !== selectedId)
        );
        setSnack({
          message: "Email programmé supprimé avec succès",
          show: true,
          severity: "success",
        });
        setRefresh((prev) => !prev);
        setOpen(false);
      })
      .catch((error) => {
        console.error(
          "Une erreur s'est produite lors de la suppression :",
          error
        );
        setOpen(false);
      });
  };

  // Colonnes du tableau
  const columns = [
    { name: "ID", label: "ID Email", options: { display: false } },
    { name: "dateSend", label: "Date programmée" },
    { name: "expediteur", label: "Expéditeur" },

    {
      name: "groupDesti",
      label: "Groupe destinataire",
      options: {
        display: false,
      },
    },
    {
      name: "listGroupeDestinataireText",
      label: "Destinataires",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          if (!value) {
            return "Aucun";
          }

          const formattedValue = value.split(",").map((item, index) => (
            <>
              <span key={index}>{item}</span>
              <br />
            </>
          ));

          return <div>{formattedValue}</div>;
        },
      },
    },
    {
      name: "modele",
      label: "Modèle",
      options: {
        customBodyRender: (value) => {
          return value ? value : "Libre";
        },
      },
    },
    {
      name: "attachement",
      label: "Fichier",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return value ? value : "Aucun";
        },
      },
    },
    {
      name: "ID",
      label: "Action",
      options: {
        customBodyRender: (value) => (
          <Tooltip title="Supprimé">
            <IconButton
              style={{ color: "#d32f2f" }}
              onClick={() => handleClickOpen(value)}
            >
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        ),
      },
    },
  ];

  const options = {
    search: true, // Activer le champ de recherche
    filter: false, // Désactiver le filtre
    sort: false, // Désactiver le tri
    download: false, // Désactiver l'export
    print: false, // Désactiver l'impression
    selectableRows: "none", // Désactiver la sélection de lignes
    viewColumns: false, // Désactiver l'affichage des colonnes
    pagination: true, // Activer la pagination
    textLabels: textLabels,
  };

  const theme = createCustomTheme(
    themeColors[themeName].headerColor,
    themeColors[themeName].color
  );

  return (
    <>
      <LoadingIndicator open={loading} />
      <MySnackbar params={snack} />
      <ThemeProvider theme={theme}>
        <MUIDataTable
          title={
            <div style={{ display: "flex", alignItems: "center" }}>
              <AccessTimeIcon style={{ marginRight: 16, marginLeft: -8 }} />
              <Typography variant="h5">Emails programmés</Typography>
            </div>
          }
          data={data}
          columns={columns}
          options={options}
        />
      </ThemeProvider>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Confirmer la suppression"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Voulez-vous vraiment supprimer cet e-mail programmé ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Annuler
          </Button>
          <Button onClick={handleConfirmDelete} color="primary" autoFocus>
            Oui
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default SchedulerTable;
